<template>
  <div class="owner-entry-page">
    <a-card class="content-card" :bordered="false">
      <template #title>
        <div class="card-title-row">
          <span>业主信息录入</span>
          <a-button icon="arrow-left" @click="goBackToQuery">
            返回查询
          </a-button>
        </div>
      </template>

      <div class="hint-row">
        <span class="muted">（楼号、房号、业主姓名、手机号码是必填项）</span>
      </div>

      <a-form class="owner-form" @submit.prevent>
        <!-- 楼号 & 房号 -->
        <a-row :gutter="16">
          <a-col :xs="24" :md="12">
            <a-form-item label="楼号" required>
              <a-input v-model="form.building" allowClear placeholder="请输入楼号，如：1" />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="12">
            <a-form-item label="房号" required>
              <a-input v-model="form.room" allowClear placeholder="请输入房号，如：101" />
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 业主姓名 & 手机 -->
        <a-row :gutter="16">
          <a-col :xs="24" :md="12">
            <a-form-item label="业主姓名" required>
              <a-input v-model="form.ownerName" allowClear placeholder="请输入业主姓名" />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="12">
            <a-form-item label="手机号码" required>
              <a-input v-model="form.phone" allowClear placeholder="请输入手机号码" />
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 身份证号 & 面积 & 状态 -->
        <a-row :gutter="16">
          <a-col :xs="24" :md="12">
            <a-form-item label="房屋面积（㎡）">
              <a-input-number
                v-model="form.area"
                :min="0"
                :step="0.01"
                style="width: 100%"
                placeholder="请输入房屋面积（可选）"
              />
            </a-form-item>
          </a-col>

          <a-col :xs="24" :md="12">
            <a-form-item label="房屋状态">
              <a-select v-model="form.status" placeholder="请选择" style="width: 100%">
                <a-select-option value="正常">正常</a-select-option>
                <a-select-option value="空置">空置</a-select-option>
                <a-select-option value="出租">出租</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 业主类型 & 催缴提前天数 --> 
        <a-row :gutter="16">
          <a-col :xs="24" :md="12">
            <a-form-item label="业主类型">
              <a-select v-model="form.ownerType" allowClear placeholder="请选择（可选）" style="width: 100%">
                <a-select-option :value="1">业主</a-select-option>
                <a-select-option :value="2">租户</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xs="24" :md="12">
            <a-form-item label="催缴提前天数">
              <a-input-number
                v-model="form.reminderDays"
                :min="0"
                :step="1"
                style="width: 100%"
                placeholder="如：5（可选）"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- 收款账号信息（新增） -->
        <a-row :gutter="16">
          <a-col :xs="24" :md="24">
            <a-form-item label="收款账号信息（可选）">
              <a-select
                v-model="form.payAccountId"
                placeholder="可不选择（可选：选择收款账号用于物业费账单）"
                style="width: 100%"
                :loading="payAccountsLoading"
                allowClear
              >
                <a-select-option
                  v-for="a in payAccounts"
                  :key="a.id"
                  :value="a.id"
                  :disabled="a.active === false"
                >
                  {{ a.bank_account_name }}｜{{ a.bank_account_no }}｜{{ a.bank_name }}
                  <span v-if="a.active === false" style="color:#999;">（停用）</span>
                </a-select-option>
              </a-select>

              <div class="helper muted" v-if="payAccounts.length === 0 && !payAccountsLoading">
                当前没有可用的收款账号（可不选择）。
              </div>
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 导入账单按钮 -->
        <a-row :gutter="16">
          <a-col :xs="24" :md="12">
            <a-form-item label="导入账单">
              <a-upload
                :before-upload="beforeUpload"
                :show-upload-list="false"
                accept=".xlsx, .xls"
                :custom-request="handleFileUpload"
              >
                <a-button icon="upload">点击上传账单</a-button>
              </a-upload>
              <!-- ✅ 新增：模板下载按钮 -->
              <a-button style="margin-left:8px" icon="download" @click="downloadBillTemplate">
                下载标准模板
              </a-button>
            </a-form-item>
          </a-col>


        <!-- 预览账单数据按钮 -->
          <a-col :xs="24" :md="12">
            <a-button type="default" @click="previewBillData">预览账单数据</a-button>
          </a-col>
        </a-row>

        <!-- 提交按钮 -->
        <div class="action-row">
          <a-button type="primary" :loading="loading" @click="submitOwner">
            录入业主信息
          </a-button>
          <a-button style="margin-left: 8px" :disabled="loading" @click="resetForm">
            重置
          </a-button>
        </div>
      </a-form>
    </a-card>

    <!-- 账单数据预览弹窗 -->
    <a-modal
      :visible="previewVisible"
      title="账单数据预览"
      :width="'80%'"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-table :data-source="form.rental_periods" :columns="columns" rowKey="period_number" :scroll="{ x: 1100 }"/>
    </a-modal>
  </div>
</template>

<script>
import request from "@/utils/request";
import * as XLSX from "xlsx"; // 用于处理上传的Excel文件

export default {
  name: "OwnerEntry",
  data() {
    return {
      loading: false,
      previewVisible: false, // 控制账单预览弹窗显示
      teamId: null,
      communityName: "",
      payAccountsLoading: false,
      payAccounts: [],
      columns: [
        { title: '租期序号', dataIndex: 'period_number' },
        { title: '款项类型', dataIndex: 'payment_type' },
        { title: '起始日期', dataIndex: 'start_date' },
        { title: '结束日期', dataIndex: 'end_date' },
        { title: '应收日期', dataIndex: 'due_date' },
        { title: '应收合计', dataIndex: 'receivable_amount' },
        { title: '实收合计', dataIndex: 'received_amount' },
        // ✅ 新增两列
        { title: '房租', dataIndex: 'rent_amount' },
        { title: '物业费', dataIndex: 'property_fee_amount' },
      ],
      form: {
        building: "",
        room: "",
        ownerName: "",
        phone: "",
        area: null,
        status: "正常",
        ownerType: null,
        reminderDays: 10,
        payAccountId: null,      // ✅ 新增：选择的收款账号 id
        rental_periods: [] // 用于缓存账单数据
      },
    };
  },
  created() {
    this.initPage()
  },
  methods: {
    async initPage () {
      await this.fetchMyTeam()
      await this.fetchPayAccounts()
    },
    async fetchMyTeam() {
      try {
        const res = await request({
          url: "/manage_data/my_team/",
          method: "get",
        });

        const data = res && res.data ? res.data : res;
        this.teamId = data.team_id;
        this.communityName = data.community_name || "";
      } catch (e) {
        console.error(e);
        this.teamId = null;
        this.communityName = "";
        this.$message.error("获取当前用户所属小区(team_id)失败，请重新登录或联系管理员");
      }
    },

    beforeUpload(file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel';
      if (!isExcel) {
        this.$message.error("请上传Excel格式的账单文件！");
      }
      return isExcel;
    },
    handleFileUpload({ file }) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];

          // raw:true => 日期可能是序列号，我们用 excelDateToYMD 转
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: true });
          if (!jsonData || jsonData.length < 2) {
            this.$message.error("Excel内容为空或缺少数据行");
            return;
          }

          const headerRow = jsonData[0];
          const headerMap = this.buildHeaderIndexMap(headerRow);

          // ✅ 表头别名：你可以按实际模板再补充
          const ALIAS = {
            period_number: ["租期序号", "期数", "期号", "period_number"],
            payment_type: ["款项类型", "付款类型", "费用类型", "payment_type"],
            start_date: ["起始日期", "开始日期", "start_date"],
            end_date: ["结束日期", "截止日期", "end_date"],
            due_date: ["应收日期", "缴费日期", "到期日期", "due_date"],
            receivable_amount: ["应收合计", "应收金额", "应收", "receivable_amount"],
            received_amount: ["实收合计", "实收金额", "实收", "received_amount"],

            // ✅ 新增两列
            rent_amount: ["房租", "租金金额", "rent_amount"],
            property_fee_amount: ["物业费", "物业费金额", "property_fee_amount"],
          };

          const rows = jsonData.slice(1);

          const rentalPeriods = rows
            .filter(row => row && row.length) // 初步过滤
            .map((row) => {
              const period_number = this.getCellByHeader(row, headerMap, ALIAS.period_number);
              const payment_type = this.getCellByHeader(row, headerMap, ALIAS.payment_type);

              // 空行过滤（核心字段都没有就跳过）
              if (
                (period_number == null || period_number === "") &&
                (!payment_type || !String(payment_type).trim())
              ) {
                return null;
              }

              const startRaw = this.getCellByHeader(row, headerMap, ALIAS.start_date);
              const endRaw = this.getCellByHeader(row, headerMap, ALIAS.end_date);
              const dueRaw = this.getCellByHeader(row, headerMap, ALIAS.due_date);

              const receivableRaw = this.getCellByHeader(row, headerMap, ALIAS.receivable_amount);
              const receivedRaw = this.getCellByHeader(row, headerMap, ALIAS.received_amount);

              const rentRaw = this.getCellByHeader(row, headerMap, ALIAS.rent_amount);
              const propRaw = this.getCellByHeader(row, headerMap, ALIAS.property_fee_amount);

              return {
                period_number: period_number != null && period_number !== "" ? Number(period_number) : null,
                payment_type: payment_type != null ? String(payment_type).trim() : "",

                start_date: this.excelDateToYMD(startRaw),
                end_date: this.excelDateToYMD(endRaw),
                due_date: this.excelDateToYMD(dueRaw),

                receivable_amount: this.toNumber(receivableRaw) ?? 0,
                received_amount: this.toNumber(receivedRaw) ?? 0,

                // ✅ 新增字段：允许为空（不填就不传或传 null，你按第三方要求）
                rent_amount: this.toNumber(rentRaw),
                property_fee_amount: this.toNumber(propRaw),
              };
            })
            .filter(Boolean);

          this.form.rental_periods = rentalPeriods;
          this.$message.success(`账单导入成功！共 ${rentalPeriods.length} 条`);
        } catch (err) {
          console.error(err);
          this.$message.error("解析Excel失败，请确认模板格式正确");
        }
      };

      reader.readAsBinaryString(file);
    },



    previewBillData() {
      this.previewVisible = true;
    },
    handleOk() {
      this.previewVisible = false;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async submitOwner() {
      const f = this.form
      if (!f.building || !f.room || !f.ownerName || !f.phone) {
        return this.$message.warning("请填写所有必填项（楼号/房号/业主姓名/手机号）")
      }

      if (!this.teamId) {
        return this.$message.warning("无法获取当前用户 team_id，请刷新页面或重新登录")
      }

      // ✅ 收款账号：允许为空（改为可选）
      const payAccountId = f.payAccountId || null

      // ✅ 字段映射：本地 API 使用的字段名
      const payload = {
        building_no: String(f.building).trim(),
        unit_no: String(f.room).trim(),
        owner_name: String(f.ownerName).trim(),
        contact_phone: String(f.phone).trim(),
        floor_area: f.area != null ? Number(f.area) : null,
        status: f.status || "正常",
        owner_type: f.ownerType != null ? Number(f.ownerType) : 1,
        reminder_days: f.reminderDays != null ? Number(f.reminderDays) : 0,
        pay_account: payAccountId,
        team_id: this.teamId,
      }

      this.loading = true
      try {
        // ✅ 调用本地 API 创建业主
        const res = await request({
          url: "/electricity/accounts/",
          method: "post",
          data: payload,
        })

        const result = res && res.data ? res.data : res
        const newAccountId = result.id

        if (newAccountId) {
          // ✅ 如果有账单数据，批量创建物业费账单
          if (f.rental_periods && f.rental_periods.length > 0) {
            await this.createPropertyBills(newAccountId, f.rental_periods)
          }

          this.$message.success("录入成功！")
          this.resetForm()
          const firstActive = this.payAccounts.find(x => x.active !== false)
          if (firstActive) this.form.payAccountId = firstActive.id
        } else {
          this.$message.error((result && result.detail) || "录入失败，请重试")
        }
      } catch (err) {
        console.error(err)
        const errMsg = err.response?.data?.detail || err.response?.data?.error || "网络错误，请稍后重试"
        this.$message.error(errMsg)
      } finally {
        this.loading = false
      }
    },

    async createPropertyBills(accountId, rentalPeriods) {
      if (!rentalPeriods || rentalPeriods.length === 0) return

      const bills = rentalPeriods
        .filter(p => p.start_date && p.end_date)  // 过滤掉缺少必填日期的记录
        .map(p => ({
          account: accountId,
          period_number: p.period_number != null ? Number(p.period_number) : null,
          payment_type: p.payment_type || "物业费",
          start_date: p.start_date,
          end_date: p.end_date,
          due_date: p.due_date || null,
          receivable_amount: p.receivable_amount || 0,
          received_amount: p.received_amount || 0,
          rent_amount: p.rent_amount || null,
          property_fee_amount: p.property_fee_amount || null,
        }))

      try {
        await request({
          url: "/electricity/property-bills/batch/",
          method: "post",
          data: { bills },
        })
        this.$message.success(`已创建 ${bills.length} 条账单`)
      } catch (err) {
        console.error("创建账单失败:", err)
        this.$message.warning("业主创建成功，但账单创建失败，请稍后手动添加")
      }
    },

    resetForm() {
      this.form = {
        building: "",
        room: "",
        ownerName: "",
        phone: "",
        area: null,
        status: "正常",
        ownerType: null,
        reminderDays: null,
        payAccountId: null,     // ✅ 新增
        rental_periods: []
      }

      // ✅ 自动回填默认启用账号（用户体验更好）
      const firstActive = this.payAccounts.find(x => x.active !== false)
      if (firstActive) this.form.payAccountId = firstActive.id
    },

    excelDateToYMD(val) {
      if (val === null || val === undefined || val === "") return "";

      // 已经是 Date
      if (val instanceof Date) {
        const y = val.getFullYear();
        const m = String(val.getMonth() + 1).padStart(2, "0");
        const d = String(val.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
      }

      // 已经是字符串（比如 2024-06-15 / 2024/6/15）
      if (typeof val === "string") {
        const s = val.trim();
        if (!s) return "";
        // 统一把 2024/6/15 => 2024-06-15
        const m = s.match(/^(\d{4})[\/\-\.](\d{1,2})[\/\-\.](\d{1,2})/);
        if (m) {
          const y = m[1];
          const mm = String(m[2]).padStart(2, "0");
          const dd = String(m[3]).padStart(2, "0");
          return `${y}-${mm}-${dd}`;
        }
        return s;
      }

      // 数字：Excel 序列号（45458 这种）
      if (typeof val === "number") {
        const d = XLSX.SSF.parse_date_code(val);
        if (d && d.y && d.m && d.d) {
          const y = d.y;
          const m = String(d.m).padStart(2, "0");
          const dd = String(d.d).padStart(2, "0");
          return `${y}-${m}-${dd}`;
        }
      }

      return String(val);
    },
    async fetchPayAccounts () {
      this.payAccountsLoading = true
      try {
        const res = await request({
          url: "/manage_data/pay_accounts/",
          method: "get",
          params: { page_size: 5000 } // 如果你后端分页
        })
        const data = (res && res.data) ? res.data : res
        const list = Array.isArray(data) ? data : (Array.isArray(data?.results) ? data.results : [])

        // 只保留当前 team 的/后端通常已过滤；这里先直接用
        this.payAccounts = list

        // ✅ 默认选中第一个启用的账号（如果用户没选）
        if (!this.form.payAccountId) {
          const firstActive = this.payAccounts.find(x => x.active !== false)
          if (firstActive) this.form.payAccountId = firstActive.id
        }
      } catch (e) {
        console.error(e)
        this.payAccounts = []
        this.$message.error("加载收款账号信息失败")
      } finally {
        this.payAccountsLoading = false
      }
    },
    // ✅ 表头标准化：去空格、全角、统一大小写
    normalizeHeaderName(name) {
      return String(name || "")
        .replace(/\s+/g, "")
        .replace(/（/g, "(")
        .replace(/）/g, ")")
        .trim()
        .toLowerCase();
    },

    // ✅ 把一行表头转成 { key: colIndex } 映射
    buildHeaderIndexMap(headerRow) {
      const map = {};
      (headerRow || []).forEach((h, idx) => {
        const k = this.normalizeHeaderName(h);
        if (!k) return;
        // 同名表头只取第一个
        if (map[k] == null) map[k] = idx;
      });
      return map;
    },

    // ✅ 按“候选表头名”取值：找不到就返回 undefined
    getCellByHeader(row, headerMap, aliases, fallbackIndex = null) {
      for (const a of aliases) {
        const key = this.normalizeHeaderName(a);
        const i = headerMap[key];
        if (i != null) return row[i];
      }
      if (fallbackIndex != null) return row[fallbackIndex];
      return undefined;
    },

    // ✅ 数字清洗（Excel 里可能带￥、逗号、空格）
    toNumber(val) {
      if (val === null || val === undefined || val === "") return null;
      if (typeof val === "number") return val;
      const s = String(val).replace(/[,\s￥¥]/g, "").trim();
      if (!s) return null;
      const n = Number(s);
      return Number.isNaN(n) ? null : n;
    },
    downloadBillTemplate() {
      // ✅ 标准模板表头（建议你就用这套字段名）
      const headers = [
        "租期序号",
        "款项类型",
        "起始日期",
        "结束日期",
        "应收日期",
        "应收合计",
        "实收合计",
        "房租",
        "物业费",
      ];

      // ✅ 预置一行示例（可删）
      const exampleRow = [
        1,
        "租金",
        "2025-03-01",
        "2025-03-31",
        "2025-03-05",
        8600,
        0,
        8200,
        400,
      ];

      // 生成 worksheet
      const ws = XLSX.utils.aoa_to_sheet([headers, exampleRow]);

      // 简单设置列宽（可选）
      ws["!cols"] = [
        { wch: 10 },
        { wch: 12 },
        { wch: 14 },
        { wch: 14 },
        { wch: 14 },
        { wch: 12 },
        { wch: 12 },
        { wch: 10 },
        { wch: 10 },
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "账单导入模板");

      const fileName = "业主账单导入模板.xlsx";
      XLSX.writeFile(wb, fileName);
    },

    goBackToQuery() {
      this.$router.push({ name: "OwnerQuery" });
    },
  },
};
</script>

<style scoped>
.owner-entry-page {
  padding: 16px;
}
.content-card {
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}
.hint-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.action-row {
  margin-top: 8px;
}
.muted {
  color: rgba(0, 0, 0, 0.45);
}
.helper {
  margin-top: 6px;
  font-size: 12px;
}
.card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
